import type { FaireProductEntity } from "../../entity_types/product";

export const p_akbabj43hf: FaireProductEntity = {
  token: "p_akbabj43hf",
  type: "product",
  name: "Breakfast in Bed Matchbook",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/c88092a6debf730fc0be09084e7361ccd7f6bc0fac282ed45d74af83f33fed28.png",
  galleryImageUrls: [],
  priceDollars: 3,
  description: "A matchbook perfect for celebrating, lighting candles, setting the vibes in your home, office, or on the go. This matchbook features 10 matches, each printed with an ingredient or icon, and blue strike heads to match. \n",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:34:01.109Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
